module.exports = __webpack_public_path__ + "static/media/spring-feet.3f164802.jpg";